import { toNumber } from '../../../../core/utils/lp-backend';
import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.order_nearby`. */
export const editOrderNearby = async (order_nearby): Promise<any> =>
  writeSettingsFields({
    order_nearby: { ...order_nearby, radius: toNumber(order_nearby?.radius) }
  });
